function characterCounter() {
    return {
        text: '',
        showAdvanced: true,
        copied: false,
        stats: {
            chars: 0, charsNoSpaces: 0, words: 0, sentences: 0, lines: 0, paragraphs: 0,
            spaces: 0, tabs: 0,
            letters: 0, digits: 0, special: 0, emojis: 0,
            readTime: '0 sec', speakTime: '0 sec', avgWordLength: 0, fleschScore: 'N/A'
        },
        topWords: [],

        init() {
            this.$watch('text', () => this.update());
        },

        formatNumber(num) {
            return new Intl.NumberFormat().format(num);
        },

        copyText() {
            if(!this.text) return;
            navigator.clipboard.writeText(this.text);
            this.copied = true;
            setTimeout(() => this.copied = false, 2000);
        },

        clearText() {
            this.text = '';
        },

        countSyllables(word) {
            word = word.toLowerCase();
            if(word.length <= 3) return 1;
            word = word.replace(/(?:[^laeiouy]es|ed|[^laeiouy]e)$/, '');
            word = word.replace(/^y/, '');
            const syllables = word.match(/[aeiouy]{1,2}/g);
            return syllables ? syllables.length : 1;
        },

        update() {
            const raw = this.text;
            if (!raw) {
                this.stats = {
                    chars: 0, charsNoSpaces: 0, words: 0, sentences: 0, lines: 0, paragraphs: 0,
                    spaces: 0, tabs: 0,
                    letters: 0, digits: 0, special: 0, emojis: 0,
                    readTime: '0 sec', speakTime: '0 sec', avgWordLength: 0, fleschScore: 'N/A'
                };
                this.topWords = [];
                return;
            }

            // Basic Counts
            const chars = raw.length; // Uses standard length (UTF-16 code units)
            const charsNoSpaces = raw.replace(/\s/g, '').length;
            const wordsArray = raw.trim().split(/\s+/).filter(w => w.length > 0);
            const words = wordsArray.length;
            const lines = raw.split(/\r\n|\r|\n/).length;
            const paragraphs = raw.split(/\n\s*\n/).filter(p => p.trim().length > 0).length;
            
            // Sentence Count (approximate)
            const sentences = raw.split(/[.!?]+/).filter(s => s.trim().length > 0).length || 1;

            // Whitespace
            const spaces = (raw.match(/ /g) || []).length;
            const tabs = (raw.match(/\t/g) || []).length;

            // Types (Regex based)
            const letters = (raw.match(/[a-zA-Z]/g) || []).length;
            const digits = (raw.match(/[0-9]/g) || []).length;
            // Emojis (Simple range check, not perfect but good enough for general use)
            const emojis = (raw.match(/[\u{1F300}-\u{1F9FF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu) || []).length;
            const special = chars - letters - digits - spaces - tabs - (lines - 1); // Rough approx

            // Readability
            const readTimeMin = words / 200;
            let readTimeDisplay = readTimeMin < 1 ? Math.ceil(readTimeMin * 60) + ' sec' : Math.ceil(readTimeMin) + ' min';
            
            const speakTimeMin = words / 130;
            let speakTimeDisplay = speakTimeMin < 1 ? Math.ceil(speakTimeMin * 60) + ' sec' : Math.ceil(speakTimeMin) + ' min';

            const avgWordLength = words > 0 ? (charsNoSpaces / words).toFixed(1) : 0;

            // Flesch Score
            let flesch = 'N/A';
            if (words > 0 && sentences > 0) {
                const totalSyllables = wordsArray.reduce((acc, w) => acc + this.countSyllables(w), 0);
                const asl = words / sentences;
                const asw = totalSyllables / words;
                const score = 206.835 - (1.015 * asl) - (84.6 * asw);
                flesch = Math.max(0, Math.min(100, Math.round(score)));
            }

            this.stats = {
                chars, charsNoSpaces, words, sentences, lines, paragraphs,
                spaces, tabs,
                letters, digits, special, emojis,
                readTime: readTimeDisplay,
                speakTime: speakTimeDisplay,
                avgWordLength,
                fleschScore: flesch
            };

            // Top Words Analysis
            const stopWords = ['a','an','the','and','or','but','in','on','at','to','of','is','are','was','were','it','that','this'];
            const wordMap = {};
            wordsArray.forEach(w => {
                const clean = w.toLowerCase().replace(/[^a-z0-9]/g, '');
                if (clean.length > 2 && !stopWords.includes(clean)) {
                    wordMap[clean] = (wordMap[clean] || 0) + 1;
                }
            });
            
            this.topWords = Object.entries(wordMap)
                .sort((a, b) => b[1] - a[1])
                .slice(0, 10)
                .map(([word, count]) => ({ word, count }));
        }
    };
}

if (typeof window.Alpine !== 'undefined') {
    Alpine.data('characterCounter', characterCounter);
} else {
    document.addEventListener('alpine:init', () => {
        Alpine.data('characterCounter', characterCounter);
    });
}
